export { XpaGoogleAdsPlaceholder } from "./legacy/xpa-components/google-ads-placeholder/XpaGoogleAdsPlaceholder";
export { gptService } from "./legacy/services/gpt-service";
